// @flow

import React, { type Node } from 'react';

import { IfFeature, type Feature } from '@tectonics/prs/feature';

import { VoucherTicket, VoucherTicketAmount, VoucherTicketDueDate } from '../commons/voucher/ticket';


type Props = {
  allFeatures: ImmutableArray<Feature>,
};

export function SpeiTicket({ allFeatures }: Props): Node {
  return (
    <VoucherTicket>
      <IfFeature allFeatures={allFeatures} wanted="display_spei_total_amount">
        <VoucherTicketAmount />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_spei_due_date">
        <VoucherTicketDueDate />
      </IfFeature>
    </VoucherTicket>
  );
}
